(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marwona-calculator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('marwona-calculator')) {
 customElements.define('marwona-calculator',class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const signal = this.abort.signal;
   const frame = this.querySelector('iframe');
   const panel = this.querySelector('[data-calculator]');
   const sticky = this.querySelector('.mwc-sticky');
   const status = this.querySelector('.mwc-load-status');
   const reload = this.querySelector('[data-reload]');
   const calculatorOrigin = new URL(frame.dataset.src).origin;
   const updateSticky = () => {
    const mobile = matchMedia('(max-width:749px)').matches;
    const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
    const consent = document.querySelector('#shopify-pc__banner:not([hidden]), #shopify-pc__prefs:not([hidden]), [role="dialog"][aria-modal="true"], dialog[open]');
    sticky.hidden = !mobile || panel.getBoundingClientRect().bottom >= 0 || !!keyboard || !!consent;
   };
   window.addEventListener('message',event => {
    if (event.origin !== calculatorOrigin || event.source !== frame.contentWindow) return;
    const data = event.data;
    if (!data || typeof data !== 'object' || data.type !== 'lovable-resize') return;
    if (typeof data.height !== 'number' || !Number.isFinite(data.height) || data.height <= 0 || data.height > 1000000) return;
    const height = Math.ceil(data.height);
    if (frame.style.height !== `${height}px`) {
     frame.style.height = `${height}px`;
     frame.setAttribute('height',String(height));
    }
    frame.dataset.autoHeight = 'true';
    clearTimeout(this.timer);
    status.hidden = true;
    updateSticky();
   },{signal});
   this.observer = new IntersectionObserver(updateSticky);
   this.observer.observe(panel);
   window.addEventListener('resize',updateSticky,{signal,passive:true});
   window.addEventListener('scroll',updateSticky,{signal,passive:true});
   window.visualViewport?.addEventListener('resize',updateSticky,{signal,passive:true});
   this.timer = setTimeout(() => { status.hidden = false; },15000);
   frame.addEventListener('load',() => { clearTimeout(this.timer); status.hidden = true; },{signal});
   frame.addEventListener('error',() => { clearTimeout(this.timer); status.hidden = false; },{signal});
   reload.hidden = false;
   reload.addEventListener('click',() => {
    status.hidden = false;
    frame.src = frame.dataset.src;
   },{signal});
   this.querySelectorAll('[data-return]').forEach(link => link.addEventListener('click',event => {
    event.preventDefault();
    panel.focus({preventScroll:true});
    panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
    sticky.hidden = true;
   },{signal}));
   if (frame.getAttribute('src') !== frame.dataset.src) frame.src = frame.dataset.src;
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-outlet"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.mwReady) return;
    root.dataset.mwReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-mw-card]'));
    const filters = root.querySelector('.mw-filters');
    const count = root.querySelector('[data-mw-count]');
    const updateCount = () => { if (count) count.textContent = String(cards.filter(card => !card.hidden).length) + ' / ' + cards.length; };
    if (filters && cards.length) {
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-mw-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = button.dataset.mwFilter !== 'all' && card.dataset.power !== button.dataset.mwFilter; });
        updateCount();
      });
      updateCount();
    }
    root.querySelectorAll('[data-mw-variant]').forEach(select => {
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const card = select.closest('[data-mw-card]');
        card.querySelector('[data-mw-price]').textContent = option.dataset.price;
        card.querySelector('[data-mw-compare-price]').textContent = option.dataset.compare;
        card.querySelector('[data-mw-compare]').hidden = !option.dataset.compare;
        const saving = card.querySelector('[data-mw-saving]');
        saving.textContent = option.dataset.saving;
        saving.hidden = !option.dataset.compare;
        card.querySelectorAll('[data-mw-product-link]').forEach(link => { link.href = option.dataset.url; });
      });
    });
    const sticky = root.querySelector('[data-mw-sticky]');
    const hero = root.querySelector('.mw-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      });
      observer.observe(hero);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
  }
  const initAll = () => document.querySelectorAll('.mw-outlet').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-raum-rechner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PARAM_KEYS = [
    'utm_source','utm_medium','utm_campaign','utm_term','utm_content',
    'gclid','gbraid','wbraid','fbclid','msclkid','ttclid'
  ];

  const withTracking = (base) => {
    try {
      const url = new URL(base);
      const page = new URL(window.location.href);
      PARAM_KEYS.forEach((key) => {
        const val = page.searchParams.get(key);
        if (val && !url.searchParams.has(key)) url.searchParams.set(key, val);
      });
      return url.toString();
    } catch (e) {
      return base;
    }
  };

  const mount = (root) => {
    if (root.dataset.mounted === 'true') return;
    root.dataset.mounted = 'true';

    const frame = root.querySelector('[data-mwr-frame]');
    const status = root.querySelector('[data-mwr-status]');
    const popout = root.querySelector('[data-mwr-popout]');
    const target = root.querySelector('#raum-rechner');
    if (!frame) return;

    const baseSrc = frame.dataset.src || 'https://bedarfsrechner.marwona.com/';
    const src = withTracking(baseSrc);
    const origin = new URL(baseSrc).origin;
    let loaded = false;
    let timer;

    if (popout) popout.href = src;

    const emit = (name, detail = {}) => {
      root.dispatchEvent(new CustomEvent('marwona:raum-rechner', {
        bubbles: true,
        detail: { event: name, page: 'listicle-7-gruende', ...detail }
      }));
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, page: 'listicle-7-gruende', ...detail });
      }
    };

    const markReady = () => {
      if (loaded) return;
      loaded = true;
      if (status) status.hidden = true;
      clearTimeout(timer);
      emit('raum_rechner_ready');
    };

    // Auto-load iframe (Wohnen-Pattern ohne Launch-Card)
    frame.src = src;
    if (status) {
      status.hidden = false;
      status.textContent = status.dataset.loading || '';
    }
    emit('raum_rechner_open', { reason: 'autoload' });
    timer = setTimeout(() => {
      if (!loaded && status) {
        status.hidden = false;
        status.textContent = status.dataset.slow || '';
      }
    }, 15000);

    frame.addEventListener('load', () => {
      // Fallback if postMessage resize never arrives
      window.setTimeout(() => {
        if (!loaded) markReady();
      }, 1200);
    });

    const receive = (event) => {
      if (event.origin !== origin || event.source !== frame.contentWindow) return;
      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === 'lovable-resize' && Number.isFinite(data.height) && data.height >= 200 && data.height <= 50000) {
        frame.style.height = `${Math.ceil(data.height)}px`;
        markReady();
      }
      if (data.type === 'lovable-act' && Number.isInteger(data.act)) {
        emit('raum_rechner_step_view', { step: data.act });
      }
    };
    window.addEventListener('message', receive);

    const scrollToRechner = (behavior) => {
      if (!target) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mode = reduce ? 'auto' : (behavior || 'smooth');
      try {
        target.scrollIntoView({ behavior: mode, block: 'start' });
      } catch (e) {
        const top = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo(0, Math.max(0, top));
      }
    };

    const wantsHash = () => (window.location.hash || '').replace(/^#/, '') === 'raum-rechner';

    if (wantsHash()) {
      scrollToRechner('auto');
      requestAnimationFrame(() => scrollToRechner('auto'));
    }
    window.addEventListener('hashchange', () => {
      if (wantsHash()) scrollToRechner('smooth');
    });

    document.querySelectorAll('a[href="#raum-rechner"]').forEach((link) => {
      link.addEventListener('click', () => {
        emit('raum_rechner_cta', { placement: 'anchor' });
        window.setTimeout(() => scrollToRechner('smooth'), 0);
      });
    });

    const cleanup = (event) => {
      if (event.target.contains(root)) {
        window.removeEventListener('message', receive);
        clearTimeout(timer);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };

  document.querySelectorAll('[data-mwr-raum]').forEach(mount);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mwr-raum]').forEach(mount);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-werksverkauf-galerie"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mw-factory-gallery')) {
  customElements.define('mw-factory-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mw-factory__track');
      this.slides = Array.from(this.querySelectorAll('.mw-factory__slide'));
      this.controls = this.querySelector('.mw-factory__controls');
      if (!this.track || !this.slides.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.count = this.querySelector('.mw-factory__count');
      this.controls.hidden = false;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-step]');
        if (!button) return;
        const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: Number(button.dataset.step) * step, behavior });
      }, options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const left = this.track.scrollLeft;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      const rect = this.track.getBoundingClientRect();
      const visible = this.slides.map((slide,index) => {
        const r = slide.getBoundingClientRect();
        return r.left >= rect.left - 3 && r.right <= rect.right + 3 ? index + 1 : null;
      }).filter(Boolean);
      if (visible.length) this.count.textContent = (visible.length > 1 ? visible[0] + '–' + visible[visible.length - 1] : visible[0]) + ' / ' + this.slides.length;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-wohnen"] && !Shopify.designMode) return;
  try {
    
(() => {
  const HEADER_SELECTORS = [
    'sticky-header',
    '[data-sticky-header]',
    '.shopify-section-group-header-group',
    '#shopify-section-header',
    'header.header'
  ];

  const headerOffset = () => {
    for (const sel of HEADER_SELECTORS) {
      const el = document.querySelector(sel);
      if (!el) continue;
      const style = window.getComputedStyle(el);
      const sticky = style.position === 'sticky' || style.position === 'fixed';
      const rect = el.getBoundingClientRect();
      if (sticky || rect.top <= 0) {
        const h = Math.max(0, Math.round(rect.height || el.offsetHeight || 0));
        if (h > 0) return h;
      }
    }
    const fallback = document.querySelector('header.header, .header');
    if (fallback) {
      const h = Math.round(fallback.getBoundingClientRect().height || 0);
      if (h > 40 && h < 200) return h;
    }
    return 0;
  };

  const applyOffsets = (root) => {
    const nav = root.querySelector('[data-mww-nav]');
    const head = headerOffset();
    root.style.setProperty('--mww-header-offset', `${head}px`);
    const navH = nav ? Math.round(nav.getBoundingClientRect().height || 0) : 0;
    const total = head + navH + 16;
    root.style.setProperty('--mww-sticky-offset', `${total}px`);
    if (nav) nav.classList.toggle('is-stuck', head > 0 && window.scrollY > 80);
  };

  const mount = (root) => {
    if (root.dataset.mounted === 'true') return;
    root.dataset.mounted = 'true';
    const frame = root.querySelector('[data-mww-frame]');
    const launch = root.querySelector('[data-mww-launch]');
    const status = root.querySelector('[data-mww-status]');
    const start = root.querySelector('[data-mww-start]');
    const target = root.querySelector('#wohnen-rechner');
    const origin = new URL(frame.dataset.src).origin;
    const seen = new Set();
    let timer;
    let started = false;
    let loaded = false;
    let scrollPasses = 0;

    const emit = (name, detail = {}) => {
      root.dispatchEvent(new CustomEvent('marwona:wohnen', {
        bubbles: true, detail: { event: name, page: 'wohnen', ...detail }
      }));
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && privacy.analyticsProcessingAllowed()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, page: 'wohnen', ...detail });
      }
    };

    const openCalculator = (reason) => {
      if (started) return;
      started = true;
      if (launch) launch.hidden = true;
      frame.hidden = false;
      status.hidden = false;
      status.textContent = status.dataset.loading;
      if (!frame.getAttribute('src')) frame.src = frame.dataset.src;
      emit('wohnen_calculator_open', { reason: reason || 'click' });
      timer = setTimeout(() => {
        if (!loaded) {
          status.hidden = false;
          status.textContent = status.dataset.slow;
        }
      }, 15000);
    };

    const scrollToCalculator = (behavior) => {
      if (!target) return;
      applyOffsets(root);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mode = reduce ? 'auto' : (behavior || 'smooth');
      try {
        target.scrollIntoView({ behavior: mode, block: 'start' });
      } catch (e) {
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
        window.scrollTo(0, Math.max(0, top));
      }
    };

    const ensureCalculatorInView = (behavior) => {
      scrollPasses = 0;
      const pass = () => {
        scrollPasses += 1;
        scrollToCalculator(behavior || (scrollPasses === 1 ? 'smooth' : 'auto'));
        if (scrollPasses < 6) {
          window.setTimeout(pass, scrollPasses < 3 ? 120 : 350);
        }
      };
      pass();
      window.addEventListener('load', () => scrollToCalculator('auto'), { once: true });
      root.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => scrollToCalculator('auto'), { once: true });
      });
    };

    const wantsCalculator = () => {
      const hash = (window.location.hash || '').replace(/^#/, '');
      return hash === 'wohnen-rechner';
    };

    const handleHash = (behavior) => {
      if (!wantsCalculator()) return;
      openCalculator('hash');
      ensureCalculatorInView(behavior || 'auto');
    };

    root.querySelectorAll('[data-mww-cta]').forEach((link) => {
      link.addEventListener('click', () => {
        emit('wohnen_calculator_cta', { placement: link.dataset.mwwCta });
        const href = link.getAttribute('href') || '';
        if (href.includes('#wohnen-rechner')) {
          openCalculator(link.dataset.mwwCta || 'cta');
          window.setTimeout(() => ensureCalculatorInView('smooth'), 0);
        }
      });
    });

    root.querySelectorAll('a[href="#wohnen-rechner"]').forEach((link) => {
      if (link.hasAttribute('data-mww-cta')) return;
      link.addEventListener('click', () => {
        openCalculator('anchor');
        window.setTimeout(() => ensureCalculatorInView('smooth'), 0);
      });
    });

    const receive = (event) => {
      if (!started || event.origin !== origin || event.source !== frame.contentWindow) return;
      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === 'lovable-resize' && Number.isFinite(data.height) && data.height >= 200 && data.height <= 50000) {
        frame.style.height = `${Math.ceil(data.height)}px`;
        status.hidden = true;
        clearTimeout(timer);
        if (!loaded) {
          loaded = true;
          emit('wohnen_calculator_ready');
          if (wantsCalculator()) scrollToCalculator('auto');
        }
      }
      if (data.type === 'lovable-act' && Number.isInteger(data.act) && data.act >= 1 && data.act <= 5) {
        if (!seen.has(data.act)) {
          seen.add(data.act);
          emit('wohnen_calculator_step_view', { step: data.act });
        }
        const rect = frame.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
          frame.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }
    };
    window.addEventListener('message', receive);

    if (start) {
      start.addEventListener('click', () => {
        openCalculator('button');
        ensureCalculatorInView('smooth');
      });
    }

    window.addEventListener('hashchange', () => handleHash('smooth'));
    window.addEventListener('resize', () => applyOffsets(root), { passive: true });
    window.addEventListener('scroll', () => applyOffsets(root), { passive: true });
    applyOffsets(root);

    if (wantsCalculator()) {
      handleHash('auto');
      requestAnimationFrame(() => handleHash('auto'));
    }

    const cleanup = (event) => {
      if (event.target.contains(root)) {
        window.removeEventListener('message', receive);
        clearTimeout(timer);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };

  document.querySelectorAll('[data-mww-wohnen]').forEach(mount);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mww-wohnen]').forEach(mount);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
